import axios from "axios";

const formHeaders = {
  "Content-Type": "multipart/form-data",
  "Access-Control-Allow-Origin": "*",
};

export const plantillaAAFF = async (data) => {
  const formData = new FormData();
  formData.append("file", data);

  try {
    const response = await axios.post(`aaff/file`, formData, {
      ...formHeaders,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const plantillaFincas = async (data, selectedChildAaffs = null) => {
  const formData = new FormData();
  formData.append("file", data);

  if (selectedChildAaffs) {
    formData.append("selectedChildAaffs", JSON.stringify(selectedChildAaffs));
  }

  try {

    const response = await axios.post(`sale/create-sales-excel`, formData, {
      ...formHeaders,
    });
    return response;
  } catch (err) {
    //console.log(err.data);
    return err;
  }
};
export const plantillaRenovaciones = async (data) => {
  const formData = new FormData();
  formData.append("file", data);

  try {
    
    const response = await axios.post(`sale/renovate-sales-multiple`, formData, {
      ...formHeaders,
    });
    return response;
  } catch (err) {
    //console.log(err.response);
    return err;
  }
};
export const plantillaFincasLOPD = async (data) => {
  
  const formData = new FormData();
  formData.append("file", data);

  try {
    
    const response = await axios.post(`sale/xlsx`, formData, {
      ...formHeaders,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
export const plantillaFincasCae = async (data) => {

  const formData = new FormData();
  formData.append("file", data);

  try {
    const response = await axios.post(`sale/cae-xlsx`, formData, {
      ...formHeaders,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
export const plantillasProveedorCae = async (data) => {
  const formData = new FormData();
  formData.append("file", data);
  try {
    const response = await axios.post(`supplier/cae-xlsx`, formData, {
      ...formHeaders,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
export const plantillaProveedores = async (data) => {
  
  const formData = new FormData();
  formData.append("file", data);

  try {
    const response = await axios.post(`supplier/file`, formData, {
      ...formHeaders,
    });
    console.log(response.data)
    return response;
  } catch (err) {
    console.log(err.data);
    return err;
  }
};
export const plantillaMatcheo = async (data) => {
  
  const formData = new FormData();
  formData.append("file", data);

  try {
    const response = await axios.post(`aaff/matchFileProp`, formData, {
      ...formHeaders,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
